import React from 'react';
import BackgroundImage from './BackgroundImage';
import LinkButtons from './LinkButtons';
import UpperCase from './UpperCase';

export default [<UpperCase />, <BackgroundImage />, <LinkButtons />];
